import { useGetIsWIPVehicle } from '~/context/vdp/VehicleContext';
import useAlertStatus from './useAlertStatus';
import useIsOnHold from './useIsOnHold';

export default function useIsPurchasableOrOnHold() {
  const { isSold, purchasePending } = useAlertStatus();
  const isOnHold = useIsOnHold();
  const isWIPVehicle = useGetIsWIPVehicle();

  const isPendingButNotOnHold = purchasePending && !isOnHold;

  return !isSold && !isWIPVehicle && !isPendingButNotOnHold;
}
